
export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-3">
            <div className="mb-8">
              <div className="flex items-center space-x-2 mb-6">
                <span className="w-2 h-2 bg-gray-900 rounded-full"></span>
                <span className="text-sm text-gray-700 font-medium">Client Testimonials</span>
              </div>

              <div className="relative">
                <span className="absolute -left-4 -top-4 text-8xl text-gray-200 font-serif">"</span>
                <blockquote className="text-4xl md:text-5xl font-light text-gray-900 leading-tight relative z-10" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Found the relaxation I've been missing<br />
                  Professional techniques helped me release all stress<br />
                  Feel refreshed after every visit
                </blockquote>
              </div>

              <div className="mt-8 flex items-center space-x-3">
                <div>
                  <div className="font-semibold text-gray-900 text-lg">Ms. Zhang</div>
                  <div className="flex items-center space-x-2 mt-1">
                    <span className="text-sm text-gray-600">Verified Customer</span>
                    <div className="flex items-center space-x-1">
                      <i className="ri-star-fill text-green-600 text-sm"></i>
                      <i className="ri-star-fill text-green-600 text-sm"></i>
                      <i className="ri-star-fill text-green-600 text-sm"></i>
                      <i className="ri-star-fill text-green-600 text-sm"></i>
                      <i className="ri-star-fill text-green-600 text-sm"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 grid grid-cols-2 gap-6">
              <div className="bg-amber-50 rounded-2xl p-6">
                <div className="flex items-center space-x-1 mb-3">
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                </div>
                <p className="text-sm text-gray-700 mb-3">
                  "Elegant environment, attentive service, very professional therapists. Feel relaxed every time I visit."
                </p>
                <div className="text-xs text-gray-600">— Mr. Li</div>
              </div>

              <div className="bg-amber-50 rounded-2xl p-6">
                <div className="flex items-center space-x-1 mb-3">
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                  <i className="ri-star-fill text-amber-600"></i>
                </div>
                <p className="text-sm text-gray-700 mb-3">
                  "High quality essential oils, excellent massage techniques, truly enjoyable experience. Highly recommended!"
                </p>
                <div className="text-xs text-gray-600">— Ms. Wang</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="relative">
              <div
                className="w-full h-[600px] rounded-3xl bg-cover bg-center"
                style={{
                  backgroundImage: 'url(https://public.readdy.ai/ai/img_res/d515fd8e0c026a12a5e0c8e662830bcd.jpg)',
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
